<div *ngIf="showMapsSelectModal" class="mapsSelectModal">
    <div class="mapsSelectModal_body">
        <div class="mapsSelectModal_title">{{pageData.title}}</div>
        <div class="mapsSelectModal_list">
            <a class="mapsSelectModal_share-link" [title]="pageData.googleMap" (click)="openInGoogleMaps()">
                <div *ngIf="pageData.googleMapIcon" class="mapsSelectModal_icons">
                    <img alt="GoogleMaps" [height]="pageData.googleMapIcon.height" [width]="pageData.googleMapIcon.width" loading="lazy" 
                        [src]="pageData.googleMapIcon.icon">
                </div>
            </a>
            <a class="mapsSelectModal_share-link" [title]="pageData.wazeMap" (click)="openInWaze()">
                <div *ngIf="pageData.wazeIcon" class="mapsSelectModal_icons">
                    <img alt="Waze" [height]="pageData.wazeIcon.height" [width]="pageData.wazeIcon.width" loading="lazy" 
                        [src]="pageData.wazeIcon.icon" >
                </div>
            </a>
        </div>
    </div>  
</div>